import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <DefaultFooter
      style={{
        background: 'none',
        padding: '24px 0',
        color: '#605c5c',
      }}
      copyright={`${currentYear} © 智栈商城管理后台 · 提供全方位数字化订单解决方案`}
      links={[]}
    />
  );
};

export default Footer;
